import {cart} from '@/app/js/cart'

const REMOVE_VOUCHER_SELECTOR = '.js-remove-voucher'
const removeVoucherElements = document.querySelectorAll(REMOVE_VOUCHER_SELECTOR)

export function initRemoveVouchers() {
  for (const removeVoucherElement of removeVoucherElements) {
    removeVoucherElement.addEventListener('click', async () => {
      const {voucherId} = removeVoucherElement.dataset
      const response = await cart.removeVoucher(voucherId)
      if (response) {
        window.location.reload()
      }
    })
  }
}
